import React, { Component } from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, 
    YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";
import { getAktiviterByUserid,setofUpdatedashboardAktivitet,decrypt,encrypt } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import {Grid} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';
const data =[
  { name:<IntlMessages id="Options.Contactperson.Short"/>, Antal: 20},
  { name:<IntlMessages id="Activities.Type.option3"/>, Antal: 5},
  { name: <IntlMessages id="Activities.Type.option1"/>, Antal: 30},
  { name:<IntlMessages id="Activities.Type.option4"/>, Antal: 10}
]
const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span style={{ color }}>{value}</span>;
}

class Aktiviteter extends Component {
  state={
    AktiviterArr:[],
    DashboardAnpassadFilterOption:[],
    done: true
  }
  intervalID = null
  componentDidMount=()=>{ 
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    axios.get(`kontos/DashBoard/getAKCBU`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
                      let endata = decrypt(res.data.encryptedData,res.data.iv)
                      let ndate = JSON.parse(endata)
                      this.setState({ 
                        AktiviterArr:ndate.results.AktiviterArr
                     });
                     this.initiateInterval() 
                      //this.setState({done: true})
                  }
    
    })
  }
      initiateInterval() {
          clearInterval(this.intervalID);
          this.intervalID= null
    this.intervalID = setInterval(
      () => {
        if(this.state.done === true){            
          //this.setState({done: false}) 
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        axios.get(`kontos/DashBoard/getAKCBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
          if(res.data.success){
            let endata = decrypt(res.data.encryptedData,res.data.iv)
            let ndate = JSON.parse(endata)
            this.setState({ 
              AktiviterArr:ndate.results.AktiviterArr
           });
           this.initiateInterval() 
            //this.setState({done: true})
        }
        })
            }
      },
      180000
  );
  console.log('test1234567', this.props.height)
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
 const isFrom= isUndefined(this.props.isFrom)?0:this.props.isFrom
 const userid = this.props.authUser.user_id;
 const Afid = this.props.authUser.user_Afid;
 if(parseInt(this.props.updatedashboardAktivitet) === 1){
  
  axios.get(`kontos/DashBoard/getAKCBU`,
  { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:[],
      intervaltype:this.props.intervaltype,
      userid:userid
    }))
  })
  .then(res => {
    if(res.data.success){
      let endata = decrypt(res.data.encryptedData,res.data.iv)
      let ndate = JSON.parse(endata)
      this.setState({ 
        AktiviterArr:ndate.results.AktiviterArr
     });
     this.initiateInterval() 
      //this.setState({done: true})
  }
  })
 
  this.props.setofUpdatedashboardAktivitet()
}
 
}
createData=()=>{
  if(isEmpty(this.state.AktiviterArr)){return [
      {name:<IntlMessages id="Options.Contactperson.Short"/>,Antal:0},
      {name:<IntlMessages id="Activities.Type.option3"/>,Antal:0},
      {name:<IntlMessages id="Activities.Type.option1"/>,Antal:0},
      {name:<IntlMessages id="Activities.Type.option4"/>,Antal:0},
  ]}
  else{
    return this.state.AktiviterArr
    }
}
formatNumber=(number)=>{
  if(number > 1000000){
    return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
}
  else if(number >= 1000){
    return `${(number/1000).toFixed(0)}K`
}else{
  return number
}
}
render() {
  const formatter = new Intl.NumberFormat('fr',{ notation: "compact" ,
   compactDisplay: "short" })
  console.log('test54555', this.state.AktiviterArr)
    return (<>{
      this.state.done === false?
      <div style={{display: "flex",flexFlow: "column",width: "95%"}}>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
      </div>
      :
    <Grid container>
        <svg width="300" height="200" style={{position: 'absolute', pointerEvents: 'none', bottom: '150px'}}>
          <linearGradient id="linearColors5"  x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#C377E0" />
          <stop offset="100%" stopColor="#44D1C2" />
          </linearGradient>
        </svg>
        <Grid xs={12} item style={{color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}>
        <ResponsiveContainer className="gx-barchart" width="95%" height={this.props.height >= 100 ? this.props.height : 200}>
        {/* <ResponsiveContainer className="gx-barchart" width="95%" height={200}> */}
        <BarChart
        // data={data}
        data={this.state.AktiviterArr}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        >
        <XAxis stroke={isUndefined(this.props.FontColor)?"#ffffff66":`${this.props.FontColor}`} tick={{ fill: isUndefined(this.props.FontColor)?'white':this.props.FontColor }} dataKey="name" />
        <YAxis stroke={isUndefined(this.props.FontColor)?"#ffffff66":`${this.props.FontColor}`} tick={{ fill: isUndefined(this.props.FontColor)?'white':this.props.FontColor }} domain={[0, 'dataMax + 1']} allowDecimals={false} type="number" tickFormatter={tick => {
              return this.formatNumber(tick)
            }}/>
        <Tooltip cursor={{ stroke: '#0E898F40', strokeWidth: 1, fill: "#0E898F40" }} 
        formatter={(value) => this.formatNumber(value)}  
        labelStyle={{ color: "#075A5F" }}
        itemStyle={{ color: "#075A5F" }}
        />
        <Legend formatter={renderColorfulLegendText} iconType="circle" />
        <Bar name={<IntlMessages id="Table.Quantity"/>} dataKey="Antal" fill="url(#linearColors5)" barSize={20} radius={[30, 30, 0, 0]} />
        </BarChart>

        </ResponsiveContainer>

        </Grid>
       
    </Grid>}</>
  );
}
};

const mapStateToProps = ({ settings,auth,DashBoard,accountsData }) => {
  const { width } = settings;
  const { authUser} = auth;
  const { updatedashboardAktivitet } = accountsData 
  const { AktiviterArr,DashboardAnpassadFilterOption} = DashBoard;
  return { width,authUser,AktiviterArr,DashboardAnpassadFilterOption,updatedashboardAktivitet };
};
function mapDispatchToProps(dispatch) {
  return {
    getAktiviterByUserid: (userid,Afid,DashboardAnpassadFilterOption,intervaltype) => dispatch(getAktiviterByUserid(userid,Afid,DashboardAnpassadFilterOption,intervaltype)),
    setofUpdatedashboardAktivitet: () => dispatch(setofUpdatedashboardAktivitet()),
   
      dispatch
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(Aktiviteter);
